import { populate } from 'populate';import dragonBones from 'pixi-dragonbones';

const raw = {
  width: 126,
  height: 176,
  x: 0,
  y: 0,
  list: [
    {
      id: 'b99ca80f-f264-4409-b075-daa92acaf166',
      type: 'Container',
      name: 'root',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: ''
    },
    {
      id: '5288a7a0-3ef3-4a1e-9e47-4c4c564e3fcb',
      type: 'Armature',
      name: 'tnt_modifier_armature',
      nameSpace: '',
      className: '',
      x: 0,
      y: 50,
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      parent: 'b99ca80f-f264-4409-b075-daa92acaf166',
      data: '',
      animationName: 'tnt',
      armatureName: 'Armature',
      dragonbonesName: 'tnt_modifier',
      playOnStart: true,
      progress: 0,
      playTimes: 0
    },
    {
      id: 'bc46b1da-a495-4f34-b913-13d9a4ec8349',
      type: 'Armature',
      name: 'tnt_modifier_ring_armature',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0,
      visible: true,
      interactive: false,
      buttonMode: false,
      parent: '5288a7a0-3ef3-4a1e-9e47-4c4c564e3fcb',
      data: '',
      animationName: 'tnt_count_down_8_4_ring',
      armatureName: 'Armature',
      dragonbonesName: 'tnt_modifier',
      playOnStart: false,
      progress: 0,
      playTimes: 0
    },
    {
      id: '567c5da6-472d-4e1d-a151-2fc94bb20c83',
      type: 'Text',
      name: 'turn_count',
      nameSpace: '',
      className: '',
      x: 77,
      y: 34,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '99',
      localize: false,
      maxWidth: 29,
      maxHeight: 32,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 35,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#892e2e',
        stroke: 'black',
        strokeThickness: 0,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '5288a7a0-3ef3-4a1e-9e47-4c4c564e3fcb',
      data: ''
    }
  ],
  version: '1.0.x'
} as const;

export class TNTModifierLayout {
  static raw = raw;
  root: PIXI.Container
  tnt_modifier_armature: dragonBones.PixiArmatureDisplay
  tnt_modifier_ring_armature: dragonBones.PixiArmatureDisplay
  turn_count: PIXI.Text

  constructor() {
    populate(this, raw);
  }
}
